module.exports = __webpack_public_path__ + "img/about_num3.33b36eb.png";